import styled from 'styled-components';
import Column from '@sdk/components/ui/spacing/Column';
import Row from '@sdk/components/ui/spacing/Row';
import Button from '@sdk/components/ui/buttons/Button';
import ProgressButton from '@sdk/components/ui/buttons/ProgressButton';

import EditBlueSvg from '@web/assets/svg/UI/edit-blue.svg';

export const EditBillingContainer = styled(Column)`
  margin: 0 auto;
  width: 730px;
`;

export const CreditCardFields = styled(Column)`
  width: 400px;
`;

export const CurrentPlanRow = styled(Row)`
  align-items: center;
  height: 76px;
`;

export const EditBillingButton = styled(Button)`
  width: 180px;
`;

export const EditBillingProgressButton = styled(ProgressButton)`
  width: 180px;
`;

export const StatusLabelContainer = styled.div`
  position: relative;
  top: -4px;
  margin-left: 10px;
`;

export const CreditCardDisplayNumber = styled.span`
  cursor: pointer;

  &:hover span {
    text-decoration: underline;
    color: ${({ theme }) => theme.colors.primary};
  }

  &:not(:hover) > svg {
    display: none;
  }
`;

export const EditCreditCardNumberIcon = styled(EditBlueSvg)`
  margin-left: 5px;
`;
